import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebSocketService } from '@app/services/websocket/WebSocketService';

@Component({
  selector: 'app-websocket-status',
  templateUrl: './websocket-status.component.html'
})
export class WebsocketStatusComponent implements OnInit, OnDestroy {
  isConnected = false;
  private subscription: Subscription | null = null;

  constructor(private webSocketService: WebSocketService) { }

  ngOnInit(): void {
    this.subscription = this.webSocketService.getConnectionStatus().subscribe(
      connected => {
        this.isConnected = connected;
      }
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  reconnect(): void {
    // Intentar reconectar el WebSocket
    this.webSocketService.connect();

    // TODO: Reimplementar solicitud de estado de usuarios si es necesario
    setTimeout(() => {
      if (this.webSocketService.isConnected()) {
        console.log('✅ WebSocket reconectado exitosamente');
      }
    }, 1000);
  }
}
